import * as types from './types'

export const addNotification = (type, text) => {
    return { type: types.NOTIFICATIONS_ADD, notification: { type: type, text: text  } };
};

export const setNotification = (type, text) => {
    window.scrollTo(0, 0);
    return { type: types.NOTIFICATIONS_SET, notification: { type: type, text: text  } };
};

export const removeNotification = (id) => {
    return { type: types.NOTIFICATIONS_REMOVE, id: id };
};

export const clearNotifications = () => {
    return { type: types.NOTIFICATIONS_CLEAR };
};
